var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 60,
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app-store",
    transform: "translate(-55 -6161)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 200,
    height: 60,
    rx: 5,
    transform: "translate(55 6161)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9729",
    "data-name": "Group 9729",
    transform: "translate(-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_",
    transform: "translate(79 6171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_37_",
    transform: "translate(0 9.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M447.361,1213.819c-3.423,5.94-1.247,14.955,2.538,20.421,1.89,2.733,3.8,5.186,6.423,5.186.049,0,.1,0,.149,0a7.926,7.926,0,0,0,2.981-.794,8.165,8.165,0,0,1,3.532-.837,7.681,7.681,0,0,1,3.361.809,7.116,7.116,0,0,0,3.22.772c2.951-.055,4.764-2.7,6.363-5.037a22.323,22.323,0,0,0,2.788-5.71l.011-.036a.332.332,0,0,0-.177-.407l-.024-.01a8.46,8.46,0,0,1-5.127-7.748,8.708,8.708,0,0,1,4.115-7.28l.032-.021a.331.331,0,0,0,.094-.466,9.575,9.575,0,0,0-7.533-4.09c-.213-.021-.435-.032-.657-.032a13.129,13.129,0,0,0-4.728,1.181,7.591,7.591,0,0,1-2.264.677,7.416,7.416,0,0,1-2.342-.685,11.35,11.35,0,0,0-4.129-1.049h-.1A10.126,10.126,0,0,0,447.361,1213.819Z",
    transform: "translate(-445.653 -1208.535)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_",
    transform: "translate(16.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M568.927,1140.038a9.244,9.244,0,0,0-6.1,3.131,8.66,8.66,0,0,0-2.193,6.422.333.333,0,0,0,.3.288c.141.011.285.016.429.016a7.822,7.822,0,0,0,5.761-2.955,9.132,9.132,0,0,0,2.146-6.607A.334.334,0,0,0,568.927,1140.038Z",
    transform: "translate(-560.578 -1140.038)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(119 6182)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Quicksand-Medium, Quicksand",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DOWNLOAD ON THE")), /*#__PURE__*/React.createElement("text", {
    id: "App_Store",
    "data-name": "App Store",
    transform: "translate(119 6208)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Quicksand-Medium, Quicksand",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "App Store"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.67fcd3226b9a9dd8a42ad31476b63c9f.svg";
export { ForwardRef as ReactComponent };